import { Container, Heading, Spinner, Stack, Text } from '@chakra-ui/react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/signin/callback')({
  component: SignupCallback,
  validateSearch: (search: Record<string, unknown>): { brief?: string | undefined } => ({
    brief: typeof search.brief === 'string' ? search.brief : undefined,
  }),
})

/**
 * Where the browser lands after signing up.
 *
 * The brief that was anonymous now belongs to a buyer, so it moves from /brief
 * to /briefs/{id}: membership rather than the cookie decides who may read it,
 * and it is addressable because sharing the address no longer gives it away.
 */
function SignupCallback() {
  const { brief } = Route.useSearch()
  const navigate = useNavigate()

  useEffect(() => {
    void navigate(
      brief === undefined
        ? // Nothing was claimed, so there is no one brief to land on. The list
          // is where a signed-in person's work lives.
          { to: '/app/briefs' }
        : { to: '/app/briefs/$briefId', params: { briefId: brief } },
    )
  }, [brief, navigate])

  return (
    <Container maxW="3xl" py="16">
      <Stack gap="4" align="start">
        <Heading size="lg">Signed up</Heading>
        <Spinner />
        <Text color="fg.muted">Taking you to your brief.</Text>
      </Stack>
    </Container>
  )
}
